import HtmlIcon from "@mui/icons-material/Html";
import JavascriptIcon from "@mui/icons-material/Javascript";
import CssIcon from "@mui/icons-material/Css";
import CodeIcon from "@mui/icons-material/Code";

const projects = {
  es: [
    {
      id: 1,
      thumb: "/images/thumbs/01.jpg",
      title: "Recetas y bebidas",
      description:
        "Página interactiva que filtra recetas y bebidas desde APIs públicas.",
      technologies: [HtmlIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Biblioteca-Comidas-y-Bebidas",
      demoUrl: "https://recetasybebidas.netlify.app/",
      url: "https://recetasybebidas.netlify.app",
    },
    {
      id: 2,
      title: "Matatena",
      thumb: "/images/thumbs/02.jpg",
      description:
        "Juego de dados para dos personas donde se calculan puntos en un tablero.",
      technologies: [HtmlIcon, CssIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Matatena",
      demoUrl: "https://matatenagame.netlify.app/",
      url: "https://matatenagame.netlify.app",
    },
    {
      id: 3,
      title: "Notas Móvil",
      thumb: "/images/thumbs/03.jpg",
      description:
        "App de notas para Android. Guarda datos localmente y crea notificaciones.",
      technologies: [JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/NotasMovil",
      url: "https://github.com/JanVal3k/NotasMovil",
    },
    {
      id: 4,
      title: "Portafolio",
      thumb: "/images/thumbs/04.jpg",
      description:
        "Este mismo portafolio con diseño moderno, accesible y adaptable.",
      technologies: [HtmlIcon, CssIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Portafolio",
      demoUrl: "https://hernangomezportafolio.netlify.app/",
      url: "https://ejemplo4.com",
    },
  ],
  en: [
    {
      id: 1,
      thumb: "/images/thumbs/01.jpg",
      title: "Recipes and Drinks",
      description:
        "Interactive website that filters recipes and drinks from public APIs.",
      technologies: [HtmlIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Biblioteca-Comidas-y-Bebidas",
      demoUrl: "https://recetasybebidas.netlify.app/",
      url: "https://recetasybebidas.netlify.app",
    },
    {
      id: 2,
      title: "Dice Game",
      thumb: "/images/thumbs/02.jpg",
      description:
        "Two-player dice game where points are calculated on a board.",
      technologies: [HtmlIcon, CssIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Matatena",
      demoUrl: "https://matatenagame.netlify.app/",
      url: "https://matatenagame.netlify.app",
    },
    {
      id: 3,
      title: "Mobile Notes",
      thumb: "/images/thumbs/03.jpg",
      description:
        "Notes app for Android. Stores data locally and creates notifications.",
      technologies: [JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/NotasMovil",
      url: "https://github.com/JanVal3k/NotasMovil",
    },
    {
      id: 4,
      title: "Portfolio",
      thumb: "/images/thumbs/04.jpg",
      description:
        "This same portfolio with a modern, accessible and responsive design.",
      technologies: [HtmlIcon, CssIcon, JavascriptIcon, CodeIcon],
      girhubUrl: "https://github.com/JanVal3k/Portafolio",
      demoUrl: "https://hernangomezportafolio.netlify.app/",
      url: "https://ejemplo4.com",
    },
  ],
};

export default projects;
